// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentSales_container__Cv7LZ","title":"RecentSales_title__3cMv4","table":"RecentSales_table__1rUv2"};